import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import Cookies from 'js-cookie'

const vuexCookie = new VuexPersistence ({
  restoreState: (key, storage) => Cookies.getJSON(key),
  saveState: (key, state, storage) => Cookies.set(key, state, {
    expires: 31,
    secure: process.env.VUE_APP_SECURE_COOKIE
  })
})

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    jwt: false,
    appli:false
  },
  mutations: {
    setJwt(state, jwt) {
      state.jwt = jwt;
    },
    setAppli(state, appli) {
      state.appli = appli;
    }
  },
  actions: {},
  modules: {},
  plugins: [
  vuexCookie.plugin
        // storeInCookie
        ]
      })